import { render, staticRenderFns } from "./MailTemplateDialog.vue?vue&type=template&id=3668ee6a"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports